<template>
  <span :class="['question-btn', gameName, region, displayModeClassName]">
    <template>
      <img
        class="tips-icon"
        :src="require(`@/assets/images/detail/common/tips.png`)"
        @click="handlePopupClick"
        alt="tips-icon"
      />
    </template>
    <van-dialog
      v-model="showPopover"
      :show-confirm-button="false"
      :show-cancel-button="false"
      :closeOnClickOverlay="true"
      className="popover-wrapper"
    >
      <div v-for="item in actions" :key="item.text" class="action-text">
        {{ item.text }}
      </div>
    </van-dialog>
  </span>
</template>

<script>
  import { trackClickBundleTip } from '../../firebase'
  import { mapState, mapGetters } from 'vuex'

  export default {
    props: {
      type: {
        default: '',
        type: String,
      },
    },
    components: {},
    data() {
      return {
        showPopover: false,
        tipColor: '#ff8522',
      }
    },
    computed: {
      ...mapState(['gameName', 'region', 'isMobile']),
      ...mapGetters(['displayModeClassName']),

      // 单独为了云原神处理一层
      tempTipsMassage() {
        return this.$t(`${this.gameName}.package_tips`)
      },

      actions() {
        const temp = this.tempTipsMassage
        let textStr = []
        if (Array.isArray(temp)) {
          textStr = temp
        }
        let packageText = textStr.map((text) => {
          return { text: text }
        })
        packageText.splice(0, 0, {
          text: this.$t(`${this.gameName}.package_instruction`),
        })

        return packageText
      },
    },
    methods: {
      handlePopupClick() {
        this.showPopover = !this.showPopover
        this.type === 'package' && trackClickBundleTip(this.gameName)
      },
    },
  }
</script>

<style lang="scss" src="./popover.scss" scoped></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './popover_pc.scss';
  }
</style>
